<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<div class="dynamic-detail">
				<div class="title">
					{{ dynamicData.investmentInformationTitle }}
				</div>
				<div class="info">
					<span>{{ dynamicData.investmentInformationPublishTime }}</span>
					<span v-if="dynamicData.investmentInformationSource">来源：{{ dynamicData.investmentInformationSource }}</span>
				</div>
				<div class="content" v-html="dynamicData.investmentInformationContent"></div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		useRoute
	} from 'vue-router'
	import {
		ElMessage
	} from 'element-plus'
	import {
		getDynamicDetail
	} from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const dynamicData = ref('');
			
			(function getData() {
				getDynamicDetail('/cdMapApi/api/park/dynamics/detail/' + route.query.dynamicId, {
					
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						// console.log('data:', data)
						// 当前渲染数据列表
						dynamicData.value = data

					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();

			return {
				dynamicData
			}
		}
	})
</script>

<style lang="scss">
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {
			.dynamic-detail {
				background: #fff;
				padding: 15px;

				.title {
					line-height: 25px;
					font-size: 18px;
					font-weight: bold;
					text-align: center;
					color: #333;
					border-bottom: #c1c1c1 1px solid;
					padding-bottom: 5px;
					margin-bottom: 10px;
				}

				.info {
					display: flex;
					justify-content: space-between;
					font-size: 13px;
					color: #999;
					height: 30px;
					line-height: 30px;
				}

				.content {
					background: #fff;
					text-justify: distribute-all-lines;
				
					img {
						width: 100%!important;
						height: auto!important;
					}
				}
			}
		}

	}
</style>
<style>
	.content img {
		width: 100%!important;
		height: auto;
	}
</style>